import React from "react";
import { Input } from "antd";
import func from "@uikit/func";
import style from "./StickieNode.module.css";

export const Stickie: React.FC<any> = props => {
  const content = props.textAreaValue?.[0]?.results?.[0]?.content || "";

  return (
    <div
      className={`${style["custom-node"]} ${
        props.isLongPress || props.checkNodeArr.includes(props.id) ? "nowheel nopan" : ""
      }`}
    >
      <div className={`${props.isLongPress ? "nodrag" : ""}`}>
        {/* 双击选中Input */}
        <div
          className={`${style["input-mask"]} ${props.isLongPress ? style["hidden-mask"] : ""}`}
          onClick={props.clickSelect}
        >
          {!props.isLongPress && (func.isEmpty(content) || typeof content === "string") ? (
            <p className={`${style["alternate-text"]} ${func.isEmpty(content) ? style["place-color"] : ""}`}>
              {content || props.placeholder}
            </p>
          ) : null}
        </div>

        <Input.TextArea
          className={`${!props.isLongPress ? "hidden-input" : ""}`}
          value={content}
          ref={props.inputRef}
          onPressEnter={props.onTextAreaEnter}
          onChange={e => props.changeInputContent(e)}
          onBlur={props.onTextAreaBlur}
          onFocus={props.onTextAreaFocus}
          placeholder={props.placeholder}
          autoSize
        />
      </div>
    </div>
  );
};

export default Stickie;
